import { Injectable } from "@angular/core";
import { Logger } from "@smallstack/core-common";
import { F_FORM, T_FORMS } from "@smallstack/typesystem";
import { DataStore } from "./data.store";
import { plural } from "pluralize";
import { snakeCaseToCamelCase } from "@smallstack/utils";
import * as i0 from "@angular/core";
import * as i1 from "./data.store";
export var StoreNames;
(function (StoreNames) {
    StoreNames["AUDIT_LOG_RECORDS"] = "AuditLogRecords";
    StoreNames["CALENDAR_ENTRIES"] = "CalendarEntries";
    StoreNames["CALENDARS"] = "Calendars";
    StoreNames["CHECKIN_EVENTS"] = "CheckinEvents";
    StoreNames["CHECKIN_VISITORS"] = "CheckinVisitors";
    StoreNames["CMS_PAGES"] = "CmsPages";
    StoreNames["COMPANIES"] = "Companies";
    StoreNames["COMPANY_USERS"] = "CompanyUsers";
    StoreNames["COUNTRIES"] = "Countries";
    StoreNames["CONTACTS"] = "Contacts";
    StoreNames["CUSTOMERS"] = "Customers";
    StoreNames["DATA_TYPES"] = "DataTypes";
    StoreNames["EMAIL_TEMPLATES"] = "EmailTemplates";
    StoreNames["FILES"] = "Files";
    StoreNames["FORMS"] = "Forms";
    StoreNames["LANGUAGES"] = "Languages";
    StoreNames["LOCALES"] = "Locales";
    StoreNames["MAILING_CHANNELS"] = "MailingChannels";
    StoreNames["MAILING_LISTS"] = "MailingLists";
    StoreNames["MESSAGES"] = "Messages";
    StoreNames["PRICE_ZONES"] = "PriceZones";
    StoreNames["PRODUCTS"] = "Products";
    StoreNames["PROJECT_MESSAGES"] = "ProjectMessages";
    StoreNames["PROJECTS"] = "Projects";
    StoreNames["TRANSLATIONS"] = "Translations";
    StoreNames["TODOS"] = "Todos";
    StoreNames["TODO_TEMPLATES"] = "TodoTemplates";
    StoreNames["USERS"] = "Users";
    StoreNames["WORKFLOWS"] = "Workflows";
    StoreNames["WORKLOGS"] = "Worklogs";
    StoreNames["MY_WORKLOGS"] = "MyWorklogs";
    StoreNames["PDF_TEMPLATES"] = "PdfTemplates";
    StoreNames["CRONJOBS"] = "cronjobs";
})(StoreNames || (StoreNames = {}));
export class StoreRegistry {
    constructor(dataStore) {
        this.dataStore = dataStore;
        this.registeredStores = {};
        this.storeRegistrationCallbacks = {};
    }
    registerStore(name, store) {
        if (name.endsWith("Store")) {
            Logger.warning("StoreRegistry", "Storename automatically corrected. Please do not register stores as 'localeStore', rather name it 'locales'!");
            name = name.replace("Store", "");
        }
        name = this.tidyStoreName(name);
        if (!name.endsWith("s"))
            Logger.warning("StoreRegistry", "Please register stores as plural, so 'locales', rather than 'locale', got " + name);
        this.registeredStores[name] = store;
        if (this.storeRegistrationCallbacks[name] instanceof Array)
            for (const callback of this.storeRegistrationCallbacks[name])
                callback(store);
    }
    removeStore(name) {
        name = this.tidyStoreName(name);
        delete this.registeredStores[name];
    }
    getStore(name) {
        name = this.tidyStoreName(name);
        // TODO: migrate old names, delete after "some" time?
        if (name === "CompanyUser")
            name = StoreNames.COMPANY_USERS;
        if (name === "Customer")
            name = StoreNames.CUSTOMERS;
        if (name === "ProjectLanguages")
            name = StoreNames.LANGUAGES;
        if (name === "ProjectLocales")
            name = StoreNames.LOCALES;
        if (name === "ProjectTranslation")
            name = StoreNames.TRANSLATIONS;
        if (name === "ProjectUser")
            name = StoreNames.USERS;
        if (name === "Forms")
            return this.dataStore.for(F_FORM, T_FORMS);
        const store = this.registeredStores[name];
        if (!store)
            Logger.warning("[StoreRegistry]", "Store '" + name + "' not found. Currently these stores are registered: " + Object.keys(this.registeredStores));
        return store;
    }
    getAllStores() {
        return this.registeredStores;
    }
    waitForStoreRegistration(storeName, callback) {
        storeName = this.tidyStoreName(storeName);
        const registeredStore = this.getStore(storeName);
        if (registeredStore !== undefined)
            return callback(registeredStore);
        if (!this.storeRegistrationCallbacks[storeName])
            this.storeRegistrationCallbacks[storeName] = [];
        this.storeRegistrationCallbacks[storeName].push(callback);
    }
    tidyStoreName(typeName) {
        return plural(snakeCaseToCamelCase(typeName, false));
    }
}
StoreRegistry.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: StoreRegistry, deps: [{ token: i1.DataStore }], target: i0.ɵɵFactoryTarget.Injectable });
StoreRegistry.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: StoreRegistry, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: StoreRegistry, decorators: [{
            type: Injectable,
            args: [{ providedIn: "root" }]
        }], ctorParameters: function () { return [{ type: i1.DataStore }]; } });
